import React from 'react';
import { Upload, Button } from 'antd';
import { apiBaseURL } from '../config';

const MyUpload = ({
  id,
  label = '',
  required = false,
  size = 60,
  value,
  setValue,
  errorMsg
}) => {

  const imageUpload = {
    name: 'image',
    action: `${apiBaseURL}/common/image/upload`,
    headers: {
      authorization: localStorage.getItem('token'),
    },
    onChange(info) {
      if (info.file.status === 'done') {
        setValue(prevFormValue => ({ ...prevFormValue, [id]: info.file.response.data.image_url }))
      }
    }
  }

  return (
    <div className="form-box">
      <label htmlFor={id}>
        {label}
        {required && <span style={{ color: '#ae2a19' }}> *</span>}
      </label>

      <div className="form-upload-box">
        <div
          className="form-upload-img"
          style={{
            width: `${size}px`,
            height: `${size}px`,
            position: 'relative',
          }}
        >
          {value && <img src={value} alt="" style={{ width: `${size}px`, height: `${size}px` }} />}
        </div>
        <div className="form-upload">
          <Upload {...imageUpload} showUploadList={false}>
            <Button>本地上传</Button>
          </Upload>
        </div>
      </div>

      {errorMsg && (
        <div className="form-errormsg">
          <p>{errorMsg}</p>
        </div>
      )}
    </div>
  );
};

export default MyUpload;
